<div class="flex flex-column consult__section consult__filiation-data">
  <div class="col-12 inline-flex flex-wrap consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center lg:col-5 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer" for="filiation-data_{{turn}}">{{screen.heading}}</label>
    </h3>
    <span class="col-12 lg:col-7 p-0 consult__section-help">{{screen.help}}</span>
  </div>

  <span class="col-12 px-0" *ngIf="expandSection">
    <textarea pInputTextarea name="filiation-data_{{turn}}" [(ngModel)]="value" [rows]="4" validation
      class="uppercase m-0"></textarea>
  </span>
</div>